import { ChangeDetectionStrategy, Component } from '@angular/core';

// The Toggle test card's body on the Test UI Components page: cs-toggle enabled and disabled, on and off.
@Component({
  selector: 'cs-test-toggle-card',
  host: { class: 'showcase-card-body' },
  template: `
    <cs-item-list>
      <cs-item-list-header data-test="toggle-test-header">Toggle test</cs-item-list-header>
      <cs-item>
        <cs-label>Enabled unchecked</cs-label>
        <cs-toggle [(checked)]="testToggle1" data-test="toggle-enabled-unchecked"></cs-toggle>
      </cs-item>
      <cs-item>
        <cs-label>Enabled checked</cs-label>
        <cs-toggle [(checked)]="testToggle2" data-test="toggle-enabled-checked"></cs-toggle>
      </cs-item>
      <cs-item>
        <cs-label>Disabled unchecked</cs-label>
        <cs-toggle [checked]="false" [disabled]="true" data-test="toggle-disabled-unchecked"></cs-toggle>
      </cs-item>
      <cs-item>
        <cs-label>Disabled checked</cs-label>
        <cs-toggle [checked]="true" [disabled]="true" data-test="toggle-disabled-checked"></cs-toggle>
      </cs-item>
    </cs-item-list>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestToggleCardComponent {
  testToggle1 = false;
  testToggle2 = true;
}
